/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerStatus
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerStatus {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerStatus
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerStatus
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerStatus
     */
    is_default?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerStatus
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerStatus
     */
    background_color?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerStatus interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerStatusFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerStatus {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerStatusFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'is_default': !exists(json, 'is_default') ? undefined : json['is_default'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'background_color': !exists(json, 'background_color') ? undefined : json['background_color'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerStatusToJSON(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'is_default': value.is_default,
        'color': value.color,
        'background_color': value.background_color,
    };
}

